// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://wowscthyngmsphkfzmob.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Indvd3NjdGh5bmdtc3Boa2Z6bW9iIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgwMzM1MDUsImV4cCI6MjA3MzYwOTUwNX0.vyKV-0oNjLlo1ncXAUd59QS5kNNn2VMTuxP7m5rKKOE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});